import get from "lodash/get";
import React, {Component} from "react";
import {render} from "react-dom";
import {ApolloProvider} from "react-apollo";
import {ApolloClient} from "apollo-client";
import {ApolloLink} from "apollo-link";
import {Provider} from "react-redux";
import {Router} from "react-router";
import {InMemoryCache} from "apollo-cache-inmemory";
import {persistStore} from "redux-persist";
import localForage from "localforage";
import createHistory from "history/createBrowserHistory";
import defaultLink from "shared/Core/defaultLink";
import Messenger from "shared/Chat/messenger";
import {APOLLO_CLIENT_NAME, APOLLO_CLIENT_VERSION} from "./shared/Utils/Constants";
import {store} from './store';
import App from "./App";

const link = ApolloLink.from([defaultLink(store)]);

const cache = new InMemoryCache();

const client = new ApolloClient({
    link,
    cache,
    name: APOLLO_CLIENT_NAME,
    version: APOLLO_CLIENT_VERSION,
});

const history = createHistory();

class AppProvider extends Component {
    state = {rehydrated: false};

    componentWillMount() {
        persistStore(
            store,
            {whitelist: ["authState"], storage: localForage},
            async () => {
                this.setState({rehydrated: true});
                const token = get(store.getState(), "authState.token", false);
                const messengerState = get(store.getState(), "messengerState");
                if (token)
                    await Messenger.connect(
                        token,
                        messengerState,
                        store.dispatch,
                    );
            },
        );
    }

    render() {
        if (!this.state.rehydrated) {
            return <div id="unibuddy-loading">Loading...</div>;
        }
        return (
            <ApolloProvider client={client}>
                <Provider store={store}>
                    <Router history={history}>
                        <App />
                    </Router>
                </Provider>
            </ApolloProvider>
        );
    }
}

render(<AppProvider />, document.getElementById("container"));
